import { AuthService } from './../../../services/auth.service';
import { Component, OnDestroy, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../../store/reducers';
import { TestTakerActions, AppUiActions } from '../../../store/actions';
import { MyModal } from '../../common/my-modal/my-modal.component';
import * as Enum from '../../../dtos/enums';
import { TestContentService } from '../../../services/test-content.service';
import { TestTakerService } from '../../../services/test-taker.service';
import { ConfigHelper } from 'app/services/config.helper';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'start-screen-microphone-check',
    template: require('./start-screen-microphone-check.component.html')
})
export class StartScreenMicrophoneCheckComponent implements OnDestroy, OnInit {
    stationNumber: number;
    testTakerPhotoUrl: string;
    errorMsg: string;
    testTakerInfo: PgRendererDto.TestTakerStationAssignment = {} as any;
    private routeParamsSubscription: Subscription;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private testTakerService: TestTakerService,
        private testContentService: TestContentService,
        private store: Store<fromRoot.State>,
        private myModal: MyModal,
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.routeParamsSubscription = this.route.params.subscribe(params => {
            if (params) {
                const stationNumber = params['station-number'];
                if (!this.testTakerService.testTakerInfo) {
                    if (!ConfigHelper.isTdpMode(true)) {
                        this.router.navigate([`start-screen/${stationNumber}/pending`]);
                    } else {
                        const accessToken = this.authService.getAccessToken();
                        if (!(accessToken && accessToken.length > 0)) {
                            const webDeliveryAuth = this.authService.getWebDeliveryAuth();
                            if (!webDeliveryAuth) {
                                this.myModal.showRegularDlg("Error", "Information missing, please restart the test from the 'My Account' page.");
                            } else {
                                this.router.navigateByUrl('/start-screen-web/' + encodeURIComponent(webDeliveryAuth));
                            }
                        }
                    }
                } else {
                    this.stationNumber = stationNumber;
                    this.testTakerInfo = this.testTakerService.testTakerInfo;
                    if (ConfigHelper.isTdpMode(true)) {
                        this.testTakerPhotoUrl = this.testTakerService.getWebDeliveryTestTakerPhotoUrl(this.testTakerInfo.ClientApplicationSessionId as string, this.testTakerInfo.TestTakerId);
                    }else {
                        this.testTakerPhotoUrl = this.testTakerService.getTestTakerPhotoUrl(this.testTakerInfo.BrandName, this.testTakerInfo.TestSessionSiteCode, this.testTakerInfo.TestTakerId);
                    }
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.routeParamsSubscription) {
            this.routeParamsSubscription.unsubscribe();
        }
    }

    clearErrorMsg() {
        this.errorMsg = "";
    }

    audioCheckCompleted() {
        if (ConfigHelper.isTdpMode(true)) {
            this.startTest();
        } else {
            this.router.navigate([`start-screen/${this.stationNumber}/start-code`]);
        }
    }

    startTest() {
        this.testTakerService.startTest().subscribe(
            success => {
                this.store.dispatch(new TestTakerActions.SetTestInitializationInfo(success));
                this.testTakerService.saveTestTakerActivityWithoutCaching(Enum.TestTakerActivityTypeEnum.StartCodeCorrectInput);
                this.router.navigate([`assessment-test/${this.testTakerInfo.AssessmentTestId}`]);
            },
            error => {
                this.myModal.showRegularDlg("Error", error);
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/tdp/start-screen/start-screen-microphone-check.component.ts